/**
 * Analytics API Service
 *
 * Handles fetching dashboard analytics from the backend API.
 * Provides type-safe interfaces for analytics data.
 */

import { api } from './api.service';

/**
 * Dashboard analytics data structure
 *
 * NOTE: Properties are in camelCase because the response interceptor
 * automatically transforms snake_case from backend to camelCase
 */
export interface DashboardAnalytics {
  totalTrucks: number;
  totalTrucksChange: number;
  dueWithin2Weeks: number;
  dueWithin2WeeksChange: number;
  dueWithin26Weeks: number;
  dueWithin26WeeksChange: number;
  dueWithin612Weeks: number;
  dueWithin612WeeksChange: number;
}

/**
 * Fetch dashboard analytics from the API
 *
 * @returns Promise<DashboardAnalytics> - Dashboard metrics and trends
 * @throws Error if the API request fails
 *
 * @example
 * const analytics = await getDashboardAnalytics();
 * console.log(`Total trucks: ${analytics.total_trucks}`);
 */
export const getDashboardAnalytics = async (): Promise<DashboardAnalytics> => {
  try {
    const response = await api.get<DashboardAnalytics>('/api/v1/analytics/dashboard');
    return response;
  } catch (error) {
    console.error('[Analytics Service] Failed to fetch dashboard analytics:', error);
    throw error;
  }
};

/**
 * Export analytics service as default
 */
export const analyticsService = {
  getDashboardAnalytics,
};

export default analyticsService;
